"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class Search extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'search';
        this._query = initParams.query;
        this._name = initParams.name;
        this._type = initParams.type;
    }
    set query(value) {
        console.error('Do not set objects this way');
    }
    get query() {
        return this._query;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    get name() {
        return this._name;
    }
    set type(value) {
        console.error('Do not set objects this way');
    }
    get type() {
        return this._type;
    }
}
exports.default = Search;
//# sourceMappingURL=search.js.map